import { render, staticRenderFns } from "./TableOrders.vue?vue&type=template&id=e6615f62&scoped=true"
import script from "./TableOrders.vue?vue&type=script&lang=js"
export * from "./TableOrders.vue?vue&type=script&lang=js"
import style0 from "./TableOrders.vue?vue&type=style&index=0&id=e6615f62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6615f62",
  null
  
)

export default component.exports